// Permite pegar una lista de correos (de Excel, Google Sheets, etc.) separados
// por salto de línea, coma, punto y coma o espacios, y la limpia/valida.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function parseEmailList(raw) {
  const seen = new Set();
  const valid = [];
  const invalid = [];

  (raw || "")
    .split(/[\n,;]+/)
    .map(s => s.trim())
    .filter(Boolean)
    .forEach(addr => {
      const key = addr.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      (EMAIL_RE.test(addr) ? valid : invalid).push(addr);
    });

  return { valid, invalid };
}
